/* src/app/admin-dashboard/category/category-edit-popup/category-edit-popup.component.css */
.popup-header {
  background-color: var(--custom-color);
  color: white;
  height: 90px;
  width: auto;
  font-size: 20px;
  padding: 30px;
  display: flex;
  align-items: center;
}
.container-fluid {
  padding-left: 30px;
  padding-right: 30px;
}
::ng-deep button.theme-button {
  background-color: white;
  color: var(--custom-color);
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  min-width: 80px;
  padding: 4px 12px;
  box-shadow: none;
  text-transform: none;
  cursor: pointer;
  text-align: center;
  margin-right: 10px;
  transition: border-color 0.3s ease;
}
.align-checkbox {
  margin-left: 50px;
}
::ng-deep button.theme-button:hover {
  background-color: white !important;
  border-top-color: rgba(0, 0, 0, 0.1);
  border-left-color: rgba(0, 0, 0, 0.1);
  border-right-color: rgba(0, 0, 0, 0.1);
  border-bottom: 2px solid var(--custom-color);
}
::ng-deep .mat-mdc-dialog-container {
  padding-top: 0 !important;
  border-radius: 15px;
  margin-bottom: 10px !important;
  max-width: 700px !important;
  width: 90vw !important;
  min-height: 300px !important;
  max-height: 80vh !important;
  height: auto !important;
  overflow: auto !important;
  display: flex !important;
  flex-direction: column !important;
}
.example-chip-list {
  width: 100%;
}
@media (min-width:629px) {
  .form-control::-webkit-input-placeholder {
    color: transparent;
  }
  .form-control:-moz-placeholder {
    color: transparent;
  }
  .form-control::-moz-placeholder {
    color: transparent;
  }
  .form-control :-ms-input-placeholder {
    color: transparent;
  }
}
@media (max-width:629px) {
  div.optionalstuff {
    display: none;
  }
}
/*# sourceMappingURL=category-edit-popup.component.css.map */
